<template>
  <section>
    <h2>Predicates</h2>
    <dl>
      <dt>In scheme</dt>
      <dd>Part of a given scheme/codelist.</dd>
      <dt>URL</dt>
      <dd />
      <dt>DOI</dt>
      <dd />
      <dt>Published</dt>
      <dd>Time when the document were published/created.</dd>
      <dt>Reference</dt>
      <dd>Can be used to connect notes together.</dd>
    </dl>
  </section>
</template>

<script>
export default {
  "name": "AboutPredicates",
};
</script>
